import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row animated fadeIn" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card shadow" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-lg-7" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline-block d-lg-inline-block" }, [
  /*#__PURE__*/_createVNode("b", null, "Balance:"),
  /*#__PURE__*/_createTextVNode(" $ ")
], -1)
const _hoisted_10 = { class: "text-primary" }
const _hoisted_11 = { class: "col-12 col-lg-5" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_14 = /*#__PURE__*/_createVNode("b", null, "Total ", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "d-none d-md-inline-block d-lg-inline-block" }, [
  /*#__PURE__*/_createVNode("b", null, "Portfolio Value"),
  /*#__PURE__*/_createTextVNode(": $ ")
], -1)
const _hoisted_16 = { class: "text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icons_currency = _resolveComponent("icons-currency")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fiats, (fiat) => {
                  return (_openBlock(), _createBlock("div", {
                    key: fiat.id,
                    class: "col-12 col-lg-6",
                    style: {"padding-left":"0px","padding-right":"0px"}
                  }, [
                    _createVNode(_component_icons_currency, {
                      localCurrency: fiat.currencyId,
                      width: '20',
                      height: '15'
                    }, null, 8, ["localCurrency"]),
                    _hoisted_8,
                    _hoisted_9,
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.formatPrice(fiat.balance)), 1),
                    _createTextVNode(" " + _toDisplayString(fiat.currencyId) + "  ", 1)
                  ]))
                }), 128))
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              (_ctx.status == 'success')
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode(_component_icons_currency, {
                      localCurrency: _ctx.currencyId,
                      width: '20',
                      height: '15'
                    }, null, 8, ["localCurrency"]),
                    _hoisted_13,
                    _hoisted_14,
                    _hoisted_15,
                    _createVNode("span", _hoisted_16, _toDisplayString(_ctx.formatPrice(_ctx.total)), 1),
                    _withDirectives(_createVNode("select", {
                      class: "border-less",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currencyId = $event))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fiatsAssets, (fiat) => {
                        return (_openBlock(), _createBlock("option", {
                          selected: "",
                          key: fiat.id,
                          value: fiat.id
                        }, _toDisplayString(fiat.id), 9, ["value"]))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.currencyId]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}